import {apiRequest, authBaseUrl, dataBaseUrl} from './apiRequest';
import {getUser} from '../utilities';

const getCustomer = async () => {
    try {
        let response = await apiRequest(authBaseUrl, '/auth/customer', {
                api: 'authAndAdmin',
                method: 'get',
                withAuth: true
            },
            'authAndAdmin'
        );
        return response;
    } catch (error) {
        throw error;
    }
};

const getOfferings = async (id) => {
    try {
        let response = await apiRequest(dataBaseUrl, `/offerings/customer/${id}`, {
            method: 'get',
            withAuth: true
        });
        return response;
    } catch (error) {
        throw error;
    }
};

const getCustomerSettings = async (id) => {
    try {
        let response = await apiRequest(dataBaseUrl, `/setting/customer/${id}`, {
                api: 'authAndAdmin',
                method: 'get',
                withAuth: true
            },
            'authAndAdmin'
        );
        return response;
    } catch (error) {
        throw error;
    }
};

const updateCustomerSettings = async (id, data) => {
    try {
        let response = await apiRequest(dataBaseUrl, `/setting/customer/${id}`, {
            method: 'put',
            data,
            withAuth: true
        });
        return response;
    } catch (error) {
        throw error;
    }
};

const saveSaleData = async (data, callback) => {
    let user = getUser();
    data = Object.assign(data, {user, date: new Date().toDateString()});
    try {
        let response;
        response = await apiRequest(dataBaseUrl, `/sales/customer/${user.customerId}`, {
            method: 'post',
            data,
            withAuth: true
        });
        callback(true, response);
        return response;
    } catch (error) {
        callback(false);
        throw error;
    }
};

const saveCacheData = async (data, callback = () => {
}) => {
    let user = getUser();
    data = Object.assign(data, {user, date: new Date().toDateString()});
    try {
        const response = await apiRequest(dataBaseUrl, `/sales/customer/${user.customerId}/offline`, {
            method: 'post',
            data,
            withAuth: true
        });
        callback(true, response);
        return response;
    } catch (error) {
        callback(false);
        throw error;
    }
};

const getSalesData = async (accountName, jobId) => {
    let user = getUser();
    try {
        let response = await apiRequest(dataBaseUrl, `/sales/customer/${user.customerId}/${accountName}/${jobId}`, {
            method: 'get',
            withAuth: true
        });
        return response;
    } catch (error) {
        throw error;
    }
};

const getMorawareData = async (jobId) => {
    try {
        let response = await apiRequest(dataBaseUrl, `/moraware/${jobId}`, {
            method: 'get',
            withAuth: true
        });
        return response;
    } catch (error) {
        throw error;
    }
};

export default {
    getCustomer,
    getOfferings,
    getCustomerSettings,
    updateCustomerSettings,
    saveSaleData,
    saveCacheData,
    getSalesData,
    getMorawareData,
};
